module.exports = __webpack_public_path__ + "media/images/footer-be5692ef60ce50a349bad48819896a4a.png";